import React, { useEffect } from 'react'
import { Container, List, LoadingContainer } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { UrineCultureItem } from '~/components/laboratoryMedicalView'
import { SpinnerIconLoader } from '~/components/shared'
import { useLaboratoryHealthProcedures } from '~/context'

export const UrineCultureList = (): JSX.Element => {
  const { displayedUrineCulture, isLoading, selectedUrineCulture, getUrineCultureDetails } =
    useLaboratoryHealthProcedures()

  useEffect(() => {
    getUrineCultureDetails(displayedUrineCulture[0])
  }, [displayedUrineCulture, getUrineCultureDetails])

  return (
    <Container>
      {isLoading ? (
        <LoadingContainer>
          <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
        </LoadingContainer>
      ) : (
        <List>
          {displayedUrineCulture.map(urineCulture => (
            <UrineCultureItem
              key={urineCulture.id}
              urineCulture={urineCulture}
              isSelected={selectedUrineCulture?.id === urineCulture.id}
              setSelected={getUrineCultureDetails}
            />
          ))}
        </List>
      )}
    </Container>
  )
}
